module.exports = __webpack_public_path__ + "img/证书@3x.48ffbd77.png";